export const globalCircleIds = [1,2] // 1:广场, 2:素材